import React from 'react';
import { motion } from 'framer-motion';
const categories = [{
  title: 'Womenswear',
  image: 'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png',
  size: 'large'
}, {
  title: 'Menswear',
  image: 'https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png',
  size: 'small'
}, {
  title: 'Bespoke Design',
  image: 'https://cdn.magicpatterns.com/uploads/gLF2b8eF4zmaV83H3cDGAQ/image.png',
  size: 'small'
}];
export function CategoryGrid() {
  return <section className="py-20 px-6 max-w-[1800px] mx-auto" data-id="element-35">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4" data-id="element-36">
        {categories.map((cat, idx) => <motion.div key={cat.title} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: idx * 0.2
      }} className={`relative group cursor-pointer overflow-hidden ${cat.size === 'large' ? 'md:col-span-8 aspect-[4/5] md:aspect-auto' : 'md:col-span-4 aspect-[4/5]'}`} data-id="element-37">
            <img src={cat.image} alt={cat.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-38" />
            <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-500" data-id="element-39" />
            <div className="absolute bottom-8 left-8" data-id="element-40">
              <h3 className="text-white text-lg md:text-2xl font-display font-bold tracking-widest uppercase" data-id="element-41">
                {cat.title}
              </h3>
              <div className="w-0 group-hover:w-full h-[1px] bg-white transition-all duration-500 mt-2" data-id="element-42" />
            </div>
          </motion.div>)}
      </div>
    </section>;
}